/* ez-cart-share — share the cart via a short link (Supabase cart-share edge function).
   Save: reads /cart.js, POSTs the snapshot (incl. line-item properties), gets a short id,
         then reveals the URL in a copy field (explicit copy, no native OS share sheet).
   Rebuild: on /cart?s=<id>, fetches the snapshot and reconstructs the cart via /cart/add.js.
   KEY is the public Supabase anon key (safe to embed). */
(function () {
  var FN  = "https://jamovldoijekfwhmlxtm.supabase.co/functions/v1/cart-share";
  var KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImphbW92bGRvaWpla2Z3aG1seHRtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzEwMTE5MjAsImV4cCI6MjA4NjU4NzkyMH0.cWgAIWDfzH4_PMXdl6jAkhkPrr630urabvpOL0582no";
  var H   = { Authorization: "Bearer " + KEY, apikey: KEY, "Content-Type": "application/json" };

  function cmdKey() { return /Mac|iPhone|iPad|iPod/.test(navigator.platform || "") ? "⌘" : "Ctrl"; }
  function setMsg(el, t) { if (el) el.textContent = t; }

  // Explicit copy: Clipboard API first, execCommand fallback (covers non-secure/older contexts).
  async function copyText(t) {
    try { if (navigator.clipboard && navigator.clipboard.writeText) { await navigator.clipboard.writeText(t); return true; } } catch (e) {}
    try {
      var ta = document.createElement("textarea");
      ta.value = t; ta.setAttribute("readonly", ""); ta.style.position = "fixed"; ta.style.top = "0"; ta.style.opacity = "0";
      document.body.appendChild(ta); ta.focus(); ta.select();
      var ok = document.execCommand("copy"); document.body.removeChild(ta); return ok;
    } catch (e) { return false; }
  }

  async function makeLink(btn, urlEl, out, msgEl) {
    var label = btn.textContent;
    btn.disabled = true; btn.textContent = "Creating link…";
    try {
      var cart = await (await fetch("/cart.js")).json();
      if (!cart.items || !cart.items.length) { setMsg(msgEl, "Your cart is empty."); out.hidden = true; return; }
      var payload = {
        cart: cart.items.map(function (i) { return { id: i.id, quantity: i.quantity, properties: i.properties || {} }; }),
        currency: cart.currency, item_count: cart.item_count, source: "cart_page"
      };
      var res = await (await fetch(FN, { method: "POST", headers: H, body: JSON.stringify(payload) })).json();
      if (!res.id) throw new Error(res.error || "save_failed");
      var link = location.origin + "/cart?s=" + res.id;
      urlEl.value = link;
      out.hidden = false;
      urlEl.focus(); urlEl.select(); try { urlEl.setSelectionRange(0, link.length); } catch (e) {}
      var copied = await copyText(link);
      setMsg(msgEl, copied ? "Link copied to clipboard ✓" : "Press " + cmdKey() + "+C to copy the link above");
      btn.textContent = "Refresh link";
    } catch (e) {
      console.error("[cart-share]", e);
      setMsg(msgEl, "Something went wrong. Try again.");
      btn.textContent = label;
    } finally {
      btn.disabled = false;
    }
  }

  async function rebuild(id) {
    try {
      var snap = await (await fetch(FN + "?s=" + encodeURIComponent(id), { headers: H })).json();
      if (!snap.cart || !snap.cart.length) return;
      if (!confirm("Load this shared cart? It will replace your current cart.")) return;
      await fetch("/cart/clear.js", { method: "POST", headers: { "Content-Type": "application/json" } });
      // Add one at a time so a single sold-out variant doesn't fail the whole cart.
      var failed = 0;
      for (var i = 0; i < snap.cart.length; i++) {
        try {
          var r = await fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ items: [snap.cart[i]] }) });
          if (!r.ok) failed++;
        } catch (e) { failed++; }
      }
      if (failed) alert(failed + (failed > 1 ? " items" : " item") + " from the shared cart " + (failed > 1 ? "are" : "is") + " no longer available and " + (failed > 1 ? "were" : "was") + " skipped.");
      location.replace(location.pathname); // drop ?s= and reload into the rebuilt cart
    } catch (e) { console.error("[cart-share] rebuild", e); }
  }

  function ensureStyle() {
    if (document.getElementById("ez-cart-share-style")) return;
    var st = document.createElement("style");
    st.id = "ez-cart-share-style";
    st.textContent =
      ".ez-cart-share{margin-top:14px;}" +
      ".ez-cart-share-btn{display:block;width:100%;padding:13px 18px;" +
      "border:1px solid rgba(255,255,255,0.55);border-radius:4px;background:transparent;" +
      "color:#ffffff;font:inherit;font-weight:700;letter-spacing:.02em;cursor:pointer;" +
      "transition:background .2s ease,border-color .2s ease;}" +
      ".ez-cart-share-btn:hover{background:rgba(255,255,255,0.10);border-color:#ffffff;}" +
      ".ez-cart-share-btn:disabled{opacity:.6;cursor:default;}" +
      ".ez-cart-share-out{margin-top:10px;}" +
      ".ez-cart-share-row{display:flex;gap:8px;align-items:stretch;}" +
      ".ez-cart-share-url{flex:1 1 auto;min-width:0;padding:11px 12px;" +
      "border:1px solid rgba(255,255,255,0.35);border-radius:4px;background:rgba(255,255,255,0.06);" +
      "color:#ffffff;font:inherit;font-size:13px;letter-spacing:.01em;text-overflow:ellipsis;}" +
      ".ez-cart-share-url:focus{outline:none;border-color:#c4622a;background:rgba(255,255,255,0.10);}" +
      ".ez-cart-share-copy{flex:0 0 auto;padding:11px 16px;border:0;border-radius:4px;" +
      "background:#c4622a;color:#ffffff;font:inherit;font-weight:700;letter-spacing:.02em;cursor:pointer;" +
      "transition:background .2s ease;}" +
      ".ez-cart-share-copy:hover{background:#a9531e;}" +
      ".ez-cart-share-msg{margin-top:7px;font-size:12px;color:rgba(255,255,255,0.78);letter-spacing:.02em;min-height:1em;}";
    document.head.appendChild(st);
  }

  function injectButton() {
    if (document.querySelector("[data-share-cart]")) return;
    var host = document.querySelector(".ez-cart-sum__content");
    if (!host) return;
    ensureStyle();
    var wrap = document.createElement("div");
    wrap.className = "ez-cart-share";
    wrap.innerHTML =
      '<button type="button" class="ez-cart-share-btn" data-share-cart>Copy cart link</button>' +
      '<div class="ez-cart-share-out" hidden>' +
        '<div class="ez-cart-share-row">' +
          '<input class="ez-cart-share-url" type="text" readonly aria-label="Shareable cart link">' +
          '<button type="button" class="ez-cart-share-copy">Copy</button>' +
        '</div>' +
        '<div class="ez-cart-share-msg" role="status" aria-live="polite"></div>' +
      '</div>';
    host.appendChild(wrap);
    var btn    = wrap.querySelector("[data-share-cart]");
    var urlEl  = wrap.querySelector(".ez-cart-share-url");
    var out    = wrap.querySelector(".ez-cart-share-out");
    var copyBt = wrap.querySelector(".ez-cart-share-copy");
    var msgEl  = wrap.querySelector(".ez-cart-share-msg");
    btn.addEventListener("click", function (e) { e.preventDefault(); makeLink(btn, urlEl, out, msgEl); });
    copyBt.addEventListener("click", async function (e) {
      e.preventDefault(); urlEl.focus(); urlEl.select();
      var ok = await copyText(urlEl.value);
      setMsg(msgEl, ok ? "Link copied ✓" : "Press " + cmdKey() + "+C to copy");
    });
    urlEl.addEventListener("focus", function () { urlEl.select(); });
    urlEl.addEventListener("click", function () { urlEl.select(); });
  }

  function init() {
    var id = new URLSearchParams(location.search).get("s");
    if (id) { rebuild(id); return; }
    injectButton();
    new MutationObserver(injectButton).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState !== "loading") init(); else document.addEventListener("DOMContentLoaded", init);
})();
